/**
 * 上传文件到 S3
 * @param {File} file 
 * @example
 *    uploadToS3(input.files[0])
 *    .then(res => {
 *      const { url } = res.data;
 *    })
 *    .catch(res => {
 *      const { code, msg } = res;
 *    });
 * 
 * 接口见:
 * https://betapetstore.corp.qihoo.net/#/document/44/?id=3300
 */

import { HelperCore } from "../helper";
import md5 from "md5";
import { request } from "..";
import uploadByApi from "./upload-api";

/**
 * 是否获取 token
 * true: 获取 token -> 上传 S3
 * false: 直接提交服务端上传，等同于 upload-api
 * 
 * token 方式，安全部门提出会暴露 ak/sk
 * 直接上传会占用服务端带宽
 */
const USE_TOKEN = false;

class S3Manager {
  data = {
    access_key_id : "",
    secret_access_key : "",
    expiration : "",
  }
  client = null;

  updateToken () {
    if(!USE_TOKEN){
      return Promise.resolve();
    }

    // 已有 token，在有效期内
    if(this.data.access_key_id && new Date(this.data.expiration) > new Date()){
      return Promise.resolve();
    }

    return request.get("/s3/token")
    .then(res => {
      const { data } = res;

      data.s3_end_point = data.s3_end_point.replace("http:", "https:");
      data.expiration = (data.expiration * 1000) + (+new Date);

      this.data = data;
      let endPoint = new AWS.Endpoint(data.s3_end_point);
      const hostArr = endPoint.host.split(".");
      this.data.bucketPrev = hostArr[0];
      AWS.config.region = this.data.bucketPrev;
      AWS.config.update({
        s3ForcePathStyle : true,
        credentials : new AWS.Credentials(this.data.access_key_id, this.data.secret_access_key, this.data.session_token),
      });

      this.client = new AWS.S3({
        endpoint : endPoint,
        params : {
          Bucket: this.data.s3_bucket,
        },
      });
    });
  }

  getClient () {
    return this.client;
  }
}
export const s3Manager = new S3Manager();

export const uploadToS3 = (file) => {
  if(!USE_TOKEN){
    return uploadByApi(file);
  }

  return new Promise((resolve, reject) => {
    const filename = file.name;
    s3Manager.updateToken()
    .then(() => {
      let fileExt = HelperCore.getFileNameExt(filename);
      const filePath = `${s3Manager.data.prefix}/${+new Date}_${md5(HelperCore.uniqueId())}.${fileExt}`;

      s3Manager.client.upload({
        Key: filePath,
        Body: file,
      }, (error, data) => {
        // debug
        // HelperCore.log(`S3 上传返回:`, error, data);

        if(error){
          reject({
            code : 1,
            msg : `上传失败`,
            data : error,
          });
        }
        else {
          /*
            {
              "Location": "https://beijing.xstore.qihu.com/zhaomi-so/client-up/1704853684811_cd62e0addbf8b7101a05e904412da6b5.png",
              "key": "client-up/1704853684811_cd62e0addbf8b7101a05e904412da6b5.png",
              "Key": "client-up/1704853684811_cd62e0addbf8b7101a05e904412da6b5.png",
              "Bucket": "zhaomi-so"
            }
           */
          const url = `${s3Manager.data.domain}/${data.Bucket}/${data.Key}`;

          resolve({
            code : 0,
            data : {
              url,
            },
          });
        }
      });
    })
    .catch(res => {
      reject(res);
    });
  });
}

if(!HelperCore.IS_ONLINE){
  window._S3Manager = s3Manager;
}